class CartDrawerRecommendations extends HTMLElement {
  static observedAttributes = [
    'data-url',
    'data-cart-count'
  ];

  constructor() {
    super();

    this.abortController = null;
    this.loadedUrl = null;
    this.loadedCartCount = null;
  }

  connectedCallback() {
    this.loadRecommendations();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  attributeChangedCallback(
    name,
    oldValue,
    newValue
  ) {
    if (
      oldValue !== newValue &&
      this.isConnected
    ) {
      this.loadRecommendations(true);
    }
  }

  async loadRecommendations(force = false) {
    const url = this.dataset.url;
    const cartCount = this.dataset.cartCount;

    const content = this.querySelector(
      '[data-recommendations-content]'
    );

    if (!url || !content) {
      return;
    }

    if (
      !force &&
      this.loadedUrl === url &&
      this.loadedCartCount === cartCount &&
      content.children.length > 0
    ) {
      return;
    }

    this.abortController?.abort();

    this.abortController =
      new AbortController();

    try {
      const response = await fetch(url, {
        signal: this.abortController.signal,
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(
          `Cart recommendations request failed: ${response.status}`
        );
      }

      const text = await response.text();

      const parser = new DOMParser();

      const documentResponse =
        parser.parseFromString(
          text,
          'text/html'
        );

      const recommendations =
        documentResponse.querySelector(
          '.cart-recommendations'
        );

      if (!this.isConnected) {
        return;
      }

      if (
        recommendations &&
        recommendations.innerHTML.trim().length > 0
      ) {
        content.replaceChildren(
          recommendations.cloneNode(true)
        );
      } else {
        content.replaceChildren();
      }

      this.loadedUrl = url;
      this.loadedCartCount = cartCount;

    } catch (error) {

      if (error.name === 'AbortError') {
        return;
      }

      console.error(
        'Cart drawer recommendations:',
        error
      );
    }
  }
}

if (
  !customElements.get(
    'cart-drawer-recommendations'
  )
) {
  customElements.define(
    'cart-drawer-recommendations',
    CartDrawerRecommendations
  );
}